export const getAggregateCardProps = (state, event, dict) => {
    return {
        event,
        sportId: event.sportId,
        handler: state.openGameTranspiler.bind(state, event),
        dict,
    };
};
//# sourceMappingURL=getAggregateCardProps.js.map